require('es6-promise').polyfill();
import { app, store } from './app';
// import Vue from 'vue';
// import vueresource from 'vue-resource';
//
// Vue.use(vueresource);
//ensure finally
Promise.prototype.finally = function(callback) {
  let P = this.constructor;
  return this.then(
    value => P.resolve(callback()).then(() => value),
    reason => P.resolve(callback()).then(() => {
      throw reason
    })
  );
};
// prime the store with server-initialized state.
// the state is determined during SSR and inlined in the page markup.
store.replaceState(window.__INITIAL_STATE__);

// actually mount to DOM
app.$mount('#app');
// service worker
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js')
}



// WEBPACK FOOTER //
// ./src/client-entry.js